export const OktaClientId = '0oa6avxblwc5lrjm2697'
export const ENV = 'workshop' as string
export const OVERSIGHT_ENV_NAME = 'oversight-lab'
export const GCS_ENV_NAME = 'workshop'
export const SUBDOMAIN_SUFFIX = 'gcs-lab'
